import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    templates: [
        {
            id: 1,
            name: 'Work In Progress',
            description: 'Notify customer that we are actively working on their complaint',
            subject: '{companyName} Support : Complaint #{complaintId} - Currently Being Processed',
            body: 'Dear {customerName},\n\nThank you for reporting your concern. We are actively investigating your complaint and will keep you updated on the progress.\nProduct: {productName}\n\nWe appreciate your patience and will resolve this as quickly as possible.\n\nBest regards,\nCustomer Support Team'
        },
        {
            id: 2,
            name: 'Need Information',
            description: 'Ask customer for more information regarding their complaint',
            subject: '{companyName} Support : Complaint #{complaintId} - Need More Information',
            body: 'Dear {customerName},\n\nTo better assist you with your complaint, we need some additional information from you.\nProduct: {productName}\n\nPlease provide the following details:\n\n1. \n2. \n3. \n\nOnce we receive this information, we will proceed with resolving your issue promptly.\n\nThank you for your cooperation.\n\nBest regards,\nCustomer Support Team'
        },
        {
            id: 3,
            name: 'Complaint Resolved',
            description: 'Notify customer that their complaint has been resolved',
            subject: '{companyName} Support : Complaint #{complaintId} - Closed',
            body: 'Dear {customerName},\n\nWe are pleased to inform you that your complaint has been successfully closed and resolved.\nProduct: {productName}\n\nOur team has taken all necessary actions to address your concern. If you have any follow-up questions or need further assistance regarding this matter, please feel free to reach out to us.\n\nThank you for bringing this to our attention and for your patience throughout the resolution process.\n\nBest regards,\nCustomer Support Team'
        }
    ],
    selectedTemplate: null,
    emailData: {
        to: '',
        subject: '',
        body: ''
    },
    validationErrors: {
        to: '',
        subject: '',
        body: ''
    },
    loading: false,
    error: null,
    success: false
};

const emailSlice = createSlice({
    name: 'email',
    initialState,
    reducers: {
        selectTemplate: (state, action) => {
            const template = state.templates.find(t => t.id === action.payload);
            state.selectedTemplate = template;
            if (template) {
                state.emailData = {
                    to: state.emailData.to,
                    subject: template.subject,
                    body: template.body
                };
            }
        },
        setEmailData: (state, action) => {
            state.emailData = {
                ...state.emailData,
                ...action.payload
            };
        },
        setRecipient: (state, action) => {
            state.emailData.to = action.payload;
        },
        resetEmailState: (state) => {
            state.selectedTemplate = null;
            state.emailData = {
                to: '',
                subject: '',
                body: ''
            };
            state.validationErrors = {
                to: '',
                subject: '',
                body: ''
            };
            state.error = null;
            state.success = false;
        },
        clearTemplate: (state) => {
            state.selectedTemplate = null;
            state.emailData = {
                to: state.emailData.to,
                subject: '',
                body: ''
            };
            state.validationErrors = {
                to: '',
                subject: '',
                body: ''
            };
        },
        setValidationErrors: (state, action) => {
            state.validationErrors = {
                ...state.validationErrors,
                ...action.payload
            };
        },
        clearValidationErrors: (state) => {
            state.validationErrors = {
                to: '',
                subject: '',
                body: ''
            };
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        setSuccess: (state, action) => {
            state.success = action.payload;
        },
        addTemplate: (state, action) => {
            const newTemplate = {
                id: Math.max(...state.templates.map(t => t.id), 0) + 1,
                ...action.payload
            };
            state.templates.push(newTemplate);
        }
    }
});

export const {
    selectTemplate,
    setEmailData,
    setRecipient,
    resetEmailState,
    clearTemplate,
    setValidationErrors,
    clearValidationErrors,
    setLoading,
    setError,
    setSuccess,
    addTemplate
} = emailSlice.actions;

export default emailSlice.reducer;
